
import {
    FrontendFilter,
    FrontendFilterGroup,
    FrontendFilterOption,
    FrontendFilterValues,
    FrontendFilterInputDate, FrontendFilterInputNumber,
    FrontendFilterInputSelectOne,
    FrontendFilterInputText, FrontendFilterInputMultiple, FrontendFilterInputBooleanSelect, FrontendFilterInputSelectOneWithSearch, FrontendFilterInputSelectMultipleWithSearch
} from "@/components/FrontendFilters/structs";
import { ModelSelect } from "vue-search-select";
import MultiSelect from 'primevue/multiselect';
import Chips from 'primevue/chips';
import _ from "lodash"

const FALSY_VALUES = [null, undefined, '']

export default {
    name: 'FrontendFilterInput',

    components: {Chips, ModelSelect, MultiSelect},

    props: {
        filterGroup: {required: true, type: Object as () => FrontendFilterGroup},
        filter: {required: true, type: Object as () => FrontendFilter},
        // Let op: De var heeft hier 'value' omdat dat de default-naam is om v-model constructies te laten werken.
        // Maar ondanks het enkelvoud bevat het wel een object met ALLE values!
        value: {required: true, type: Object as () => FrontendFilterValues},
        disabled: {required: false, type: Boolean, default: false},
        placeholder: { required: false, type: String },
        isInline: {required: false, type: Boolean, default: false},
    },

    data() {
        return {
            updateOptions: 0,
            filteredOptions: [] as FrontendFilterOption[],
            debouncedWidthUpdate: _.debounce(this.updateContainerWidthForValue, 500),
            internalValue: '' as string | undefined,
        }
    },

    async mounted() {
        this.internalValue = this.value[this.filter.identifier]?.toString()

        if (this.filter.inputType instanceof FrontendFilterInputBooleanSelect) {
            this.$set(this.filter, 'options', [
                new FrontendFilterOption('1', this.$t('omt.gui.general.yes').toString()),
                new FrontendFilterOption('0', this.$t('omt.gui.general.no').toString()),
            ])
        }
        else if (this.filter.inputType instanceof FrontendFilterInputSelectMultipleWithSearch && !this.value[this.filter.identifier]?.length) {
            this.value[this.filter.identifier] = []
        }

        if (this.isInline) {
            this.updateContainerWidthForValue()
        }

        // Zet eerst gewoon alle opties neer en ga daarna (mogelijk asynchroon) de opties filteren
        this.filteredOptions = this.filter.options
        this.setFilteredOptions()

        this.updateOptions++;
    },

    computed: {
        options(): FrontendFilterOption[] {
            // noinspection BadExpressionStatementJS
            this.updateOptions; // Hack to force update of this computed var

            let options: FrontendFilterOption[] = structuredClone(this.filteredOptions)

            if (!(this.filter.inputType instanceof FrontendFilterInputSelectMultipleWithSearch)) {
                options.unshift(new FrontendFilterOption('', ''))
            }

            return _.sortBy(options, 'text')
        },
        currentFilterValue(): any {
            return this.value[this.filter.identifier]
        },
        currentFilterDisplayValue(): string | null {
            if (!this.filter.options.length) {
                return this.currentFilterValue
            }

            return this.options.find((option: FrontendFilterOption) => option.value === this.currentFilterValue)?.text ?? null
        },

        actualPlaceholder() {
            return this.placeholder ?? this.filter.inputType.config.placeholder?.(this.value)
        },
        FrontendFilterInputNumber() {
            return FrontendFilterInputNumber
        },
        FrontendFilterInputDate() {
            return FrontendFilterInputDate
        },
        FrontendFilterInputBooleanSelect() {
            return FrontendFilterInputBooleanSelect
        },
        FrontendFilterInputSelectOne() {
            return FrontendFilterInputSelectOne
        },
        FrontendFilterInputSelectOneWithSearch() {
            return FrontendFilterInputSelectOneWithSearch
        },
        FrontendFilterInputSelectMultipleWithSearch() {
            return FrontendFilterInputSelectMultipleWithSearch
        },
        FrontendFilterInputText() {
            return FrontendFilterInputText
        },
        FrontendFilterInputMultiple() {
            return FrontendFilterInputMultiple
        },
        inputCssClasses() {
            return {
                'border-primary': !FALSY_VALUES.includes(this.value[this.filter.identifier] as string | null | undefined) && !this.isInputDisabled && !this.isInline,
                'text-primary': !FALSY_VALUES.includes(this.value[this.filter.identifier] as string | null | undefined) && !this.isInputDisabled && this.isInline,
                'text-bold': !FALSY_VALUES.includes(this.value[this.filter.identifier] as string | null | undefined) && !this.isInputDisabled && this.isInline,
            }
        },
        isInputDisabled() {
            return this.disabled || this.filter.inputType.config.disabled?.(this.filter, this.value)
        },
        optionsForFrontendFilterInputSelectOneWithSearch(): Record<string,string>[] {
            const accumulator: Record<string,string>[] = []

            return this.options.reduce((acc, option: FrontendFilterOption) => {
                acc.push({ text: option.text, value: option.value });
                return acc;
            }, accumulator);
        },
    },

    methods: {
        updateContainerWidthForValue() {
            const inputContainerRef: Record<string,any> | undefined = this.$refs['inputContainer']

            let value = this.currentFilterDisplayValue
            if (!value) value = this.actualPlaceholder

            if (typeof value === 'string' && value && inputContainerRef) {
                inputContainerRef.style.width = `${value.length + 8}ch`
            }
        },
        setFilteredOptions(): void {
            const output = this.filter.filteredOptions(this.filter.options, this.value) ?? []

            if (output instanceof Promise) {
                output.then((filteredOptions: FrontendFilterOption[]) => this.filteredOptions = filteredOptions)
                return
            }

            this.filteredOptions = output
        }
    },

    watch: {
        internalValue(newVal) {
            if (!newVal?.toString().trim().length) {
                this.internalValue = undefined
            }

            this.setFilteredOptions()
            this.$set(this.value, this.filter.identifier, newVal)
        },
        currentFilterValue() {
            if (this.isInline) {
                this.debouncedWidthUpdate()
            }
        },
        filteredOptions(val) {
            if (val.length && !val.some((option: FrontendFilterOption) => option.value === this.currentFilterValue)) {
                this.value[this.filter.identifier] = undefined;
            }
        },
    }
}
